module.exports = __webpack_public_path__ + "static/img/22.f5c52ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/22.png
// module id = UZPr
// module chunks = 0